$(document).ready(function() {
  if (window.innerWidth <= 768) {  // Check for mobile screen width
var flkty = new Flickity('.mobile-slider-custom1', {
    cellAlign: 'center',  // Center-align images
    contain: true,         // Prevent images from overflowing
    autoPlay: 3000,        // Auto slide every 3 seconds
    wrapAround: true,      // Loop back to the first image
    prevNextButtons: false, // Hide next/prev buttons
    pageDots: true,        // Show dots for navigation
    draggable: true,       // Enable dragging/swiping
    groupCells: true,      // Ensure only one image is shown per slide
    // Responsive options
    responsive: [
        {
            breakpoint: 768, // For mobile screens
            settings: {
                groupCells: 1,  // Show 1 slide at a time on mobile
            }
        }
    ]
});



    var flkty = new Flickity('.mobile-slider-custom2', {
      cellAlign: 'center',  // Center-align images
      contain: true,         // Prevent images from overflowing
      autoPlay: 3000,        // Auto slide every 3 seconds
      wrapAround: true,      // Loop back to the first image
      prevNextButtons: false, // Hide next/prev buttons
      pageDots: true,        // Show dots for navigation
      draggable: true        // Enable dragging/swiping
    });


    var flkty = new Flickity('.mobile-slider-custom3', {
      cellAlign: 'center',  // Center-align images
      contain: true,         // Prevent images from overflowing
      autoPlay: 3000,        // Auto slide every 3 seconds
      wrapAround: true,      // Loop back to the first image
      prevNextButtons: false, // Hide next/prev buttons
      pageDots: true,        // Show dots for navigation
      draggable: true        // Enable dragging/swiping
    });

    var flkty = new Flickity('.mobile-slider-custom4', {
      cellAlign: 'center',  // Center-align images
      contain: true,         // Prevent images from overflowing
      autoPlay: 3000,        // Auto slide every 3 seconds
      wrapAround: true,      // Loop back to the first image
      prevNextButtons: false, // Hide next/prev buttons
      pageDots: true,        // Show dots for navigation
      draggable: true        // Enable dragging/swiping
    });

    var flkty = new Flickity('.mobile-slider-custom5', {
      cellAlign: 'center',  // Center-align images
      contain: true,         // Prevent images from overflowing
      autoPlay: 3000,        // Auto slide every 3 seconds
      wrapAround: true,      // Loop back to the first image
      prevNextButtons: false, // Hide next/prev buttons
      pageDots: true,        // Show dots for navigation
      draggable: true        // Enable dragging/swiping
    });

    var flkty = new Flickity('.mobile-slider-custom6', {
      cellAlign: 'center',  // Center-align images
      contain: true,         // Prevent images from overflowing
      autoPlay: 3000,        // Auto slide every 3 seconds
      wrapAround: true,      // Loop back to the first image
      prevNextButtons: false, // Hide next/prev buttons
      pageDots: true,        // Show dots for navigation
      draggable: true        // Enable dragging/swiping
    });
    
    
  }
});